import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { BaseDialog } from '@components/common/BaseDialog';
import { getMetAiSearchExplanation, MetAiSearchExplanation } from '@services/met-activity.service';

interface MetAiSearchExplanationDialogProps {
  open: boolean;
  onClose: () => void;
}

/** Як AI шукає активність у базі MET - текст з бекенду (модуль met-activities). */
export const MetAiSearchExplanationDialog: React.FC<MetAiSearchExplanationDialogProps> = ({ open, onClose }) => {
  const [data, setData] = useState<MetAiSearchExplanation | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!open || data) return;
    getMetAiSearchExplanation()
      .then(setData)
      .catch(() => setError(true));
  }, [open, data]);

  return (
    <BaseDialog open={open} onClose={onClose} maxWidth="md" title={data?.title ?? 'Як AI шукає активність у базі MET'}>
      {error ? (
        <Typography color="error">Не вдалося завантажити пояснення</Typography>
      ) : !data ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}><CircularProgress size={24} /></Box>
      ) : (
        <Box sx={{ '& h2': { typography: 'h6', mt: 2, mb: 1 }, '& p, & li': { typography: 'body2' }, '& blockquote': { m: 0, pl: 2, borderLeft: 3, borderColor: 'warning.main' } }}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.markdown}</ReactMarkdown>
          <Typography variant="caption" color="text.secondary">Оновлено: {data.updatedAt}</Typography>
        </Box>
      )}
    </BaseDialog>
  );
};
